/**
 * Demo mode: URL path `/dashboard/demo[/...]` serves mock data instead of
 * hitting the API. Used for public showcases - no auth required, no write
 * operations take effect.
 */

export const DEMO_STORE_ID = 'demo';

export function isDemoMode(): boolean {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname.replace(/\/+$/, '');
  // Web bundle is served at /dashboard/, so the demo entry is /dashboard/demo.
  // The Capacitor WebView serves at capacitor://localhost/ (no /dashboard
  // prefix), so the demo entry there is just /demo.
  return path === '/dashboard/demo' || path.startsWith('/dashboard/demo/')
      || path === '/demo' || path.startsWith('/demo/');
}

export function isDemoStoreId(storeId: string | null | undefined): boolean {
  return storeId === DEMO_STORE_ID;
}
